import SendEmailIcon from './SendEmailIcon';

export default SendEmailIcon;
